<template>
    <div>
        <router-view :key="id"></router-view>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String
        },
        id: {
            type: String
        },
    },
    methods: {
        async component() {
            console.log("COMPONENT", this.id)
            return await this.$store.getters.componentSettings(this.id)
        }
    },
    created() {
        this.$store.commit("SET_CURRENT_COMPONENT", this.id)

    },
    mounted() {
        //console.log("REF", this.id)
    },
    updated() {
        this.$store.commit("SET_CURRENT_COMPONENT", this.id)
    }
}
</script>